﻿import render from '@tk/utilities/tk.render';

const showDimmer = (elementToAttach?: HTMLElement, style?: Record<string, string>) => {
    if (elementToAttach) {
        const dimmer = render('<div class="tk-dimmer tk-dimmer--attached"></div>');
        style &&
            Object.keys(style).forEach((key) => {
                dimmer.style.setProperty(key, style[key]);
            });
        elementToAttach.insertAdjacentElement('beforeend', dimmer);
        return dimmer;
    } else {
        const dimmer = render('<div class="tk-dimmer"></div>');
        const dialog = Array.from(document.querySelectorAll('dialog[open]'));
        dialog.length > 0
            ? dialog.at(-1)?.insertAdjacentElement('beforeend', dimmer)
            : document.body.insertAdjacentElement('beforeend', dimmer);
        return dimmer;
    }
};

export default showDimmer;
